import { Link } from "react-scroll";

export default function HomeBanner() {
  return (
    <div id="section1" className="home-banner">
      <div className="home-banner-mask"></div>
      <div className="name-text">
        <h3>Hey! i am</h3>
        <i>
          <h1>
            Umang
            <br />
            Gadhavana.
          </h1>
        </i>
      </div>

      <div className="visit-btn">
        <Link
          activeClass="active"
          to="section2"
          spy={true}
          smooth={true}
          offset={-80}
          duration={100}
        >
          <button>visit</button>
        </Link>
      </div>
    </div>
  );
}
